
export class AddressRequest {
   public name: string;
   public address: string;
   public address2: string;
   public city: string;
   public state: string;
   public zipCode: string;
}
